import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Table, Column } from '../components/ui/Table';
import { Plus, Search, BadgeCheck, Ban } from 'lucide-react';
import { InterestProfileForm } from '../components/InterestProfileForm';
interface Interest {
  id: string;
  interestId: string;
  type: string;
  status: 'active' | 'inactive';
}
export function InterestSetup() {
  const [isCreating, setIsCreating] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  // Mock Data
  const interests: Interest[] = [{
    id: '1',
    interestId: 'INT-001',
    type: 'Fixed Rate',
    status: 'active'
  }, {
    id: '2',
    interestId: 'INT-002',
    type: 'Variable Rate (LIBOR)',
    status: 'active'
  }, {
    id: '3',
    interestId: 'INT-003',
    type: 'Reducing Balance',
    status: 'active'
  }, {
    id: '4',
    interestId: 'INT-004',
    type: 'Flat Rate',
    status: 'active'
  }, {
    id: '5',
    interestId: 'INT-005',
    type: 'Compound Interest',
    status: 'active'
  }, {
    id: '6',
    interestId: 'INT-006',
    type: 'Simple Interest',
    status: 'inactive'
  }, {
    id: '7',
    interestId: 'INT-007',
    type: 'Hybrid (Fixed + Variable)',
    status: 'active'
  }];
  const filteredInterests = interests.filter(i => i.type.toLowerCase().includes(searchQuery.toLowerCase()) || i.interestId.toLowerCase().includes(searchQuery.toLowerCase()));
  const columns: Column<Interest>[] = [{
    key: 'interestId',
    label: 'Interest ID'
  }, {
    key: 'type',
    label: 'Interest Type',
    render: item => <span className="font-medium text-gray-900" data-id="element-2070">{item.type}</span>
  }, {
    key: 'status',
    label: 'Status',
    render: item => <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-2071">
          {item.status === 'active' ? <BadgeCheck className="w-3 h-3 mr-1" data-id="element-2072" /> : <Ban className="w-3 h-3 mr-1" data-id="element-2073" />}
          {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
        </span>
  }];
  if (isCreating) {
    return <InterestProfileForm onBack={() => setIsCreating(false)} onSave={() => {
      // In a real app, this would save the data
      setIsCreating(false);
    }} data-id="element-2074" />;
  }
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-2075">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-2076">
        <div data-id="element-2077">
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-2078">
            Interest & Markup Setup
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-2079">
            Manage interest rate types and calculation methods for loan
            products.
          </p>
        </div>
        <Button size="lg" className="shadow-sm" onClick={() => setIsCreating(true)} data-id="element-2080">
          <Plus className="mr-2 h-5 w-5" data-id="element-2081" />
          Add New Interest Type
        </Button>
      </div>

      {/* Search */}
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-2082">
        <div className="relative" data-id="element-2083">
          <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-2084" />
          <Input placeholder="Search interest types by ID or type..." className="pl-10 border-0 bg-gray-50 focus:bg-white transition-colors" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2085" />
        </div>
      </div>

      {/* Table */}
      <Table columns={columns} data={filteredInterests} onRowClick={interest => console.log('Clicked interest:', interest)} keyExtractor={item => item.id} data-id="element-2086" />
    </div>;
}